module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03-m-en.6a15870155e868d9340296323373acc9.png";